import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { ShareRevokeParams } from '../DocumentVault.meta';
import { queryKeys } from './queryKeys';

const shareWithThirdParty = ({ clientId, path, providerType }: ShareRevokeParams) => {
  return authFetch(
    urlWithParams('/Consumer/DocumentVault/ShareWithThirdParty', {
      clientId,
      path,
      providerType,
    }),
    { method: 'POST' },
  );
};

export const useShareWithThirdPartyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(shareWithThirdParty, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.listDocumentVaultEntities());
    },
  });
};
